module.exports = __webpack_public_path__ + "img/Value.b5801b80.svg";